import React from "react";

export default function DrugDispensedIcon(props) {
  return (
    <svg width={23} height={22} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="M11.5 10.5L14.9787 13.9954C16.3405 15.3487 16.3403 17.539 14.9787 18.8922C13.617 20.2455 11.4131 20.2453 10.0515 18.8922C7.37482 16.232 4.69814 13.5719 2.0215 10.9117C0.659724 9.55839 0.659924 7.36807 2.0215 6.01493C3.38325 4.66159 5.58716 4.66179 6.94874 6.01493L11.5 10.5ZM11.5 10.5L6.41882 15.2819"
          stroke="#CA367E"
          strokeWidth="1.5"
        />
        <path d="M7 15L11 11" stroke="#2B56A3" strokeWidth={2} strokeLinecap="round" />
        <circle cx={5} cy={17} r="4.25" fill="white" stroke="#CA367E" strokeWidth="1.5" />
        <path d="M23 1.42L21.59 0L15 6.59L12.41 4.01L11 5.42L15 9.42L23 1.42Z" fill="#2B56A3" />
        <path d="M3 19L7 15" stroke="#2B56A3" strokeWidth={2} strokeLinecap="round" />
      </g>
    </svg>
  );
}
